(function () {
  function fixBrokenPrice() {

    // ✅ Nur Produktseiten (Dawn-kompatibel)
    if (![...document.body.classList].some(c => c.startsWith('template-product'))) return;

    // 🎯 Pumper + Dawn Preis-Targets
    const selectors = [
      '.trans-money',
      '.price__container .price-item',
      '.price__container .price-item--sale'
    ];

    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        if (!el) return;

        const txt = el.textContent;

        // Escaped HTML sichtbar → reparieren
        if (txt.includes('<span')) {
          const fixed = txt
            .replace(/<[^>]+>/g, '')
            .replace(/\s+/g, ' ')
            .trim();

          el.textContent = fixed;
          el.style.visibility = 'visible';
        }
      });
    });
  }

  // 🧠 Initial
  document.addEventListener('DOMContentLoaded', fixBrokenPrice);

  // 🔁 Dawn / Pumper dynamisch
  const observer = new MutationObserver(fixBrokenPrice);
  observer.observe(document.body, { childList: true, subtree: true });

})();
